// TYPES
import { IFormCadastroRg } from 'pages/iirgd/RgFicDigital/CadastroRg/form';
import { ReducerActionRotaSP } from 'store/modules/types';
import { IConsultarDare } from '../../dare/consultarDare/types';
import { RequestAlterarObservacoes, Types } from './types';

export function alterarObservacoesValuesTemp(
	payload: RequestAlterarObservacoes,
): ReducerActionRotaSP {
	return {
		type: Types.ALTERAR_OBSERVACOES_VALUES_TEMP,
		payload,
	};
}

export function alterarObservacoesRequest(
	token: string,
	formObservacoes: RequestAlterarObservacoes,
	dare: IConsultarDare | null,
	cadastroRg: IFormCadastroRg | null,
): ReducerActionRotaSP {
	return {
		type: Types.ALTERAR_OBSERVACOES_REQUEST,
		payload: {
			formObservacoes,
			dare,
			cadastroRg,
		},
		token,
	};
}

export function alterarObservacoesSuccess(
	status: number,
	cadastrodeCpf?: boolean,
	mensagemCPF?: string | null,
): ReducerActionRotaSP {
	return {
		type: Types.ALTERAR_OBSERVACOES_SUCCESS,
		payload: {
			status,
			cadastrodeCpf,
			mensagemCPF,
		},
	};
}

export function alterarObservacoesFailure(): ReducerActionRotaSP {
	return {
		type: Types.ALTERAR_OBSERVACOES_FAILURE,
		payload: null,
	};
}

export function alterarObservacoesClear(): ReducerActionRotaSP {
	return {
		type: Types.ALTERAR_OBSERVACOES_CLEAR,
		payload: null,
	};
}
